import React, { useEffect, useState } from "react";
import { TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import config from "../config";
import { useAuth } from "../context/Auth";
import Employee from "../entities/Employee";

interface Props {
  defaultValue?: Employee[];
  onChange?: (value: Employee[]) => void;
  disabled?: boolean;
}

const EmployeesSelect = ({ defaultValue, onChange, disabled }: Props) => {
  const [employees, setEmployees] = useState<Employee[]>([]);
  const [selected, setSelected] = useState<Employee[]>(defaultValue || []);
  const { fetchWithUser } = useAuth();

  useEffect(() => {
    const url = `${config.apiUrl}/Employee/GetBaseEmployeeList`;
    fetchWithUser(url)
      .then((response: any) => response.json())
      .then((data: Employee[]) => setEmployees(data))
      .catch((error: any) => console.error("Error fetching employees:", error));
  }, [fetchWithUser]);

  return (
    <Autocomplete
      multiple
      disabled={disabled}
      options={employees}
      getOptionLabel={(option) => {
        const first = option.firstName || "";
        const last = option.lastName || "";
        return `${first} ${last}`.trim() || `Employee ${option.employeeID}`;
      }}
      getOptionSelected={(option, value) => option.employeeID === value.employeeID}
      value={selected}
      onChange={(event, newValue: Employee[]) => {
        setSelected(newValue);
        if (onChange) {
          onChange(newValue);
        }
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          label="Employees"
          placeholder="Select employees"
        />
      )}
    />
  );
};

export default EmployeesSelect;
